import S from './GlobalSpinnerStyles';

function GlobalSpinner({ working = true }: any): JSX.Element {
  return working ? (
    <S.Wrapper>
      <div className="spinner-obj">
        <div />
        <div />
        <div />
        <div />
      </div>
    </S.Wrapper>
  ) : (<div className="hidden" />);
}

export default GlobalSpinner;
